import Home from 'src/features/routes/home/Home';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { getLocalUserId, PERMISSION } from 'src/features/auth';
import MainLayout from 'src/components/layout/MainLayout';
import HomeRedirect from 'src/features/routes/home/HomeRedirect';
import { useListUserMemberships } from 'src/features/profile/api/useListUserMemberships';

const HomeRoutes = () => {
    const accessHomeStats = useHasPermissions([PERMISSION.ACCESS_HOME_STATS]);

    const userId = getLocalUserId();
    const { data: userMemberships } = useListUserMemberships({ userId });
    const isClient = Boolean(userMemberships && userMemberships[0]?.is_client);

    return <MainLayout>{accessHomeStats || isClient ? <Home isClient={isClient} /> : <HomeRedirect />}</MainLayout>;
};

export default HomeRoutes;
